export default "__VITE_PUBLIC_ASSET__95eaa00a__"